<template>
  <ul class="content-links">
    <li
      v-for="link of data"
      :key="link.href"
    >
      <a
        :href="'#' + link.href"
        v-text="link.title"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ContentLinks',
  props: {
    data: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.content-links {
  list-style-type: none;
  padding: 0;
}

.content-links li {
  display: inline-block;
  margin-right: 20px;
}

.content-links li a {
  text-decoration: underline;
  text-decoration-style: dashed;
  color: #696969;
}

.content-links li a:hover {
  color: inherit;
}
</style>
